import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";

const PROJECTS = [
  { img: IMAGES.work2, title: "Lanzamiento de marca", cat: "Branding · RRSS", span: "md:col-span-7" },
  { img: IMAGES.work4, title: "Estrategia Instagram", cat: "Community", span: "md:col-span-5" },
  { img: IMAGES.work3, title: "Campaña de growth", cat: "Marketing", span: "md:col-span-5" },
  { img: IMAGES.work1, title: "Rediseño web", cat: "Diseño Web", span: "md:col-span-7" },
];

export const Portfolio = () => {
  return (
    <section
      id="proyectos"
      data-testid="portfolio-section"
      className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 md:py-32"
    >
      <div className="flex items-end justify-between mb-12">
        <div>
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-green mb-4">
            Proyectos seleccionados
          </p>
          <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.9]">
            Trabajo que<br />habla por sí solo.
          </h2>
        </div>
      </div>

      <div className="grid md:grid-cols-12 gap-4 md:gap-5">
        {PROJECTS.map((p, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 2) * 0.08 }}
            data-testid={`project-card-${i}`}
            className={`group relative overflow-hidden rounded-3xl ${p.span} aspect-[4/3] cursor-pointer`}
          >
            <img
              src={p.img}
              alt={p.title}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-forest/90 via-forest/10 to-transparent opacity-80" />
            <div className="absolute bottom-0 left-0 p-7 md:p-9 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
              <p className="text-mango text-xs font-bold tracking-[0.2em] uppercase mb-2">
                {p.cat}
              </p>
              <h3 className="font-display font-bold text-2xl md:text-3xl text-cream tracking-tight">
                {p.title}
              </h3>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
